export default "__VITE_ASSET__SOCzsR0Z__"